import type { Fallacy } from "./types";
import { createStory } from "./types";

export const anchoringBias: Fallacy = {
    id: "anchoring-bias",
    name: "Anchoring Bias",
    emoji: "⚓",
    category: "Manipulasi Statistik",
    description: "Angka pertama yang disebut menjadi **'jangkar'** yang **mempengaruhi penilaian** kita, meski tidak relevan.",
    tldr: "\"Harga asli 5jt, sekarang cuma 500rb!\" — emang beneran 5jt?",
    detail: "Anchoring Bias adalah kecenderungan kognitif di mana otak kita **terlalu bergantung pada informasi pertama** (angka 'jangkar') yang diterima saat membuat keputusan.\n\nFenomena ini sering dieksploitasi dalam pemasaran dan negosiasi. Label \"Harga asli Rp5.000.000, DISKON jadi Rp500.000!\" membuat otak otomatis membandingkan dengan 5jt dan merasa untung besar — padahal harga aslinya belum tentu benar.\n\nCara melawan: **Lakukan riset independen** sebelum terpapar angka pertama. Tanyakan: \"Kalau saya tidak melihat angka awal itu, apakah harga ini tetap wajar?\" Bandingkan dengan harga pasar, bukan dengan jangkar yang sengaja dipasang.",
    story: createStory("Anchoring Bias", "⚓", {
      hook: {
        title: "\"Harga asli 5 juta, sekarang 500rb!\"",
        body: "Kamu ngerasa untung gede? Tapi... emang beneran pernah dijual 5 juta?",
      },
      convo: {
        claim: "Flash sale laptop **harga asli 25 juta, sekarang cuma 5 juta**. Hemat 20 juta, gila sih ini murah banget!",
        response: "Cek marketplace lain, spek sama 5-6 juta. **Angka 25 juta itu jangkar palsu.**",
      },
      reveal: {
        body: "Otak kamu **terlalu nempel sama angka pertama** yang dilihat. Angka itu jadi \"jangkar\" yang bikin semua penilaian setelahnya ikut tertarik.",
      },
      insight: {
        title: "Kenapa gampang kena?",
        body: "Otak kamu butuh **titik referensi** buat menilai sesuatu. Penjual yang jago sengaja pasang angka gede duluan biar harga asli keliatan murah.",
      },
      engagement: {
        title: "Pernah ketipu harga coret?",
        body: "Di marketplace atau toko offline? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["framing-effect", "misleading-statistics", "decoy-effect"],
  };
